export const shellStylesheet = String.raw`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    background: var(--herefor-color-canvas);
    color: var(--herefor-color-text-primary);
    font-family:
      Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    line-height: var(--herefor-line-height-normal);
  }

  body {
    margin: 0;
    min-inline-size: 20rem;
  }

  button,
  a {
    font: inherit;
  }

  a {
    color: inherit;
  }

  a:focus-visible,
  button:focus-visible {
    border-radius: var(--herefor-radius-sm);
    box-shadow: var(--herefor-focus-ring);
    outline: none;
  }

  .app-shell {
    min-block-size: 100vh;
    min-block-size: 100dvh;
    background: var(--herefor-color-canvas);
  }

  .shell-header {
    background: var(--herefor-color-surface);
    border-block-end: 1px solid var(--herefor-color-border);
  }

  .shell-header__inner,
  .shell-body {
    inline-size: min(100% - (2 * var(--herefor-space-4)), 76rem);
    margin-inline: auto;
  }

  .shell-header__inner {
    min-block-size: 4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--herefor-space-4);
  }

  .shell-brand {
    min-block-size: 2.75rem;
    display: inline-flex;
    align-items: center;
    color: var(--herefor-color-accent);
    font-size: var(--herefor-font-size-xl);
    font-weight: var(--herefor-font-weight-semibold);
    text-decoration: none;
  }

  .shell-body {
    padding-block: var(--herefor-space-5) var(--herefor-space-7);
  }

  .shell-navigation {
    display: flex;
    gap: var(--herefor-space-2);
    margin: 0 0 var(--herefor-space-5);
    padding: 0 0 var(--herefor-space-2);
    overflow-x: auto;
    list-style: none;
    scrollbar-width: thin;
  }

  .shell-navigation__link {
    min-block-size: 2.75rem;
    display: inline-flex;
    align-items: center;
    padding-inline: var(--herefor-space-4);
    border: 1px solid transparent;
    border-radius: var(--herefor-radius-pill);
    color: var(--herefor-color-text-muted);
    font-weight: var(--herefor-font-weight-medium);
    text-decoration: none;
    white-space: nowrap;
  }

  .shell-navigation__link:hover {
    background: var(--herefor-color-surface-subtle);
    color: var(--herefor-color-text-primary);
  }

  .shell-navigation__link[aria-current="page"] {
    background: var(--herefor-color-accent);
    color: var(--herefor-color-text-on-accent);
  }

  .shell-main {
    min-inline-size: 0;
  }

  .shell-panel {
    min-block-size: 24rem;
    padding: clamp(var(--herefor-space-5), 5vw, var(--herefor-space-7));
    background: var(--herefor-color-surface);
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-lg);
    box-shadow: var(--herefor-elevation-raised);
  }

  .shell-panel h1 {
    max-inline-size: 28ch;
    margin: 0;
    font-size: clamp(var(--herefor-font-size-2xl), 5vw, var(--herefor-font-size-3xl));
    line-height: var(--herefor-line-height-tight);
  }

  .shell-placeholder {
    display: grid;
    gap: var(--herefor-space-4);
    margin-block-start: var(--herefor-space-6);
  }

  .shell-placeholder__line,
  .shell-placeholder__card {
    background: var(--herefor-color-surface-subtle);
    border: 1px solid var(--herefor-color-border);
  }

  .shell-placeholder__line {
    block-size: 0.875rem;
    inline-size: min(70%, 28rem);
    border-radius: var(--herefor-radius-pill);
  }

  .shell-placeholder__card {
    block-size: 6rem;
    border-radius: var(--herefor-radius-md);
  }

  .shell-error {
    max-inline-size: 42rem;
  }

  .shell-error p {
    color: var(--herefor-color-text-muted);
    font-size: var(--herefor-font-size-lg);
  }

  .shell-action {
    min-block-size: 2.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-block-start: var(--herefor-space-3);
    padding-inline: var(--herefor-space-5);
    background: var(--herefor-color-accent);
    border-radius: var(--herefor-radius-md);
    color: var(--herefor-color-text-on-accent);
    font-weight: var(--herefor-font-weight-semibold);
    text-decoration: none;
  }

  .shell-action:hover {
    background: var(--herefor-color-accent-hover);
  }

  @media (min-width: 48rem) {
    .shell-body--with-navigation {
      display: grid;
      grid-template-columns: 13rem minmax(0, 1fr);
      gap: var(--herefor-space-6);
      align-items: start;
    }

    .shell-navigation {
      position: sticky;
      inset-block-start: var(--herefor-space-5);
      display: grid;
      margin: 0;
      padding: 0;
      overflow: visible;
    }

    .shell-navigation__link {
      inline-size: 100%;
      border-radius: var(--herefor-radius-md);
    }
  }
`;
